const config = {
  url: process.env.REACT_APP_API_URL,
  trackingReportUrl: process.env.REACT_APP_TRACKING_REPORT_URL,
  brandChannelApiUrl: process.env.REACT_APP_BRAND_CHANNEL_API_URL,
  keen: {
    report: {
      projectId: process.env.REACT_APP_KEEN_REPORT_PROJECTID,
      readKey: process.env.REACT_APP_KEEN_REPORT_READKEY
    },
    tracking: {
      projectId: process.env.REACT_APP_KEEN_TRACKING_PROJECTID,

      writeKey: process.env.REACT_APP_KEEN_TRACKING_WRITEKEY
    }
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config.js